/**
 * PopupBaseMap - Simple OSM base map for popup windows
 * 
 * Unlike the main app's BaseMap which uses useSettings() with full settings,
 * this component works with the simplified PopupSettingsProvider and just
 * renders an OSM tile layer.
 */
import React from 'react';
import { OSMTileLayer } from '@ais-ui/react-openlayers';

export const PopupBaseMap: React.FC = () => {
  // Use default OpenStreetMap tiles
  return <OSMTileLayer />;
};
